<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row :gutter="20" type="flex" align="middle">
            <el-col :span="6">
              <el-form-item label="年份" prop="year">
                <el-date-picker v-model="year" value-format="yyyy" format="yyyy" type="year" @change="yearChange" placeholder="选择年" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="季度" prop="quarter">
                <el-select v-model="quarter" @change="quarterChange" placeholder="请选择" style="width:100%">
                  <el-option :key="index" v-for="(item,index) in quarterOptions" :label="item.label" :value="item.key"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="月份" prop="month">
                <el-select v-model="month" placeholder="请选择" style="width:100%">
                  <el-option :key="index" v-for="(item,index) in monthOptions" :label="item.label" :value="item.key"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-button size="mini" class="btn" type="primary" @click="onAdd">新增评价期</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" type="flex" align="middle">
            <el-col :span="6">
              <el-form-item label="评价时间" prop="ratingPeriod">
                <el-input v-model="queryCondition.ratingPeriod" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="对比评价时间" prop="peerRatingPeriod">
                <el-input v-model="queryCondition.peerRatingPeriod" disabled type="textarea" :autosize="{ minRows: 1, maxRows: 4}" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-button size="mini" class="btn" type="primary" @click="onContrast">新增对比评价期</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" type="flex" justify="center">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" @click="onExport" type="primary">导出</el-button>
      </el-row>
      <el-row>
        <div class="title_box">
          <p class="line"></p>
          <p class="title">Monthly analysis (%)</p>
        </div>
      </el-row>
      <div v-for="(item,index) in tableLists" :key="index" style="width:100%;overflow: auto;margin-bottom:15px">
        <table class="table">
          <tr>
            <td class="table_td" style="width:80px">评价时间</td>
            <td class="table_td" style="width:90px">对比评价时间</td>
            <td class="table_td" style="width:70px">Grade</td>
            <td class="table_td" style="width:70px">AAA</td>
            <td class="table_td" style="width:70px">QBR</td>
            <td class="table_td" style="width:70px">MSV</td>
            <td class="table_td" style="width:70px">{{labelName}}</td>
            <td class="table_td" style="width:70px">SQMS</td>
            <td class="table_td" style="width:100px">Gov`t Cert</td>
            <td class="table_td" style="width:120px">Spec Compliance</td>
            <td class="table_td" style="width:70px">COA</td>
            <td class="table_td" style="width:120px">Reg Compliance</td>
            <td class="table_td" style="width:120px">Gov`t Plant Audit</td>
            <td class="table_td" style="width:120px">Stock Recovery</td>
            <td class="table_td" style="width:70px">QIP</td>
            <td class="table_td" style="width:120px">Product Feedback</td>
            <td class="table_td" style="width:70px">Sensory</td>
            <td class="table_td" style="width:140px">Consumer Feedback</td>
            <td class="table_td" style="width:70px">DQMP</td>
            <td class="table_td" style="width:120px">RMC Chicken</td>
            <td class="table_td" style="width:120px">RMC Produce</td>
            <td class="table_td" style="width:120px">Antibiotic Chicken</td>
          </tr>
          <tr>
            <td style="width:80px">{{item.abPerformanceInfo.period}}</td>
            <td style="width:90px"></td>
            <td style="width:70px">A+B</td>
            <td style="width:70px">
              <span>{{Math.round(parseFloat((item.abPerformanceInfo.aaa* 100).toPrecision(12)))}}%</span>
            </td>
            <td style="width:70px">
              <span>{{Math.round(parseFloat((item.abPerformanceInfo.qbr* 100).toPrecision(12)))}}%</span>
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.abPerformanceInfo.msv* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.abPerformanceInfo.swa* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.abPerformanceInfo.sqms* 100).toPrecision(12)))}}%
            </td>
            <td style="width:100px">
              {{Math.round(parseFloat((item.abPerformanceInfo.govtCert* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.abPerformanceInfo.specComp* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.abPerformanceInfo.coa* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.abPerformanceInfo.regComp* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.abPerformanceInfo.govtPlant* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.abPerformanceInfo.stockRecovery* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.abPerformanceInfo.qip* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.abPerformanceInfo.feedback* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.abPerformanceInfo.sensory* 100).toPrecision(12)))}}%
            </td>
            <td style="width:140px">
              {{Math.round(parseFloat((item.abPerformanceInfo.consumerFeedback* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.abPerformanceInfo.dqmp* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.abPerformanceInfo.rmcChick* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.abPerformanceInfo.rmcProduce* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.abPerformanceInfo.antiChick* 100).toPrecision(12)))}}%
            </td>
          </tr>
          <tr>
            <td style="width:80px"></td>
            <td style="width:90px">{{item.peerAbPerformanceInfo.period}}</td>
            <td style="width:70px">A+B</td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.peerAbPerformanceInfo.aaa* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.peerAbPerformanceInfo.qbr* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.peerAbPerformanceInfo.msv* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.peerAbPerformanceInfo.swa* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.peerAbPerformanceInfo.sqms* 100).toPrecision(12)))}}%
            </td>
            <td style="width:100px">
              {{Math.round(parseFloat((item.peerAbPerformanceInfo.govtCert* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.peerAbPerformanceInfo.specComp* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.peerAbPerformanceInfo.coa* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.peerAbPerformanceInfo.regComp* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.peerAbPerformanceInfo.govtPlant* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.peerAbPerformanceInfo.stockRecovery* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.peerAbPerformanceInfo.qip* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.peerAbPerformanceInfo.feedback* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.peerAbPerformanceInfo.sensory* 100).toPrecision(12)))}}%
            </td>
            <td style="width:140px">
              {{Math.round(parseFloat((item.peerAbPerformanceInfo.consumerFeedback* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.peerAbPerformanceInfo.dqmp* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.peerAbPerformanceInfo.rmcChick* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.peerAbPerformanceInfo.rmcProduce* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.peerAbPerformanceInfo.antiChick* 100).toPrecision(12)))}}%
            </td>
          </tr>
          <tr>
            <td style="width:170px" :colspan="2" class="table_td_grade" @click="abClick(item)">Grade A+B 趋势</td>
            <td style="width:70px">A+B</td>
            <td style="width:70px">
              <i v-if="Number(item.abTrend.aaa)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.abTrend.aaa)>=0">
                {{Math.round(parseFloat((item.abTrend.aaa* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.abTrend.aaa)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.abTrend.aaa)<0">
                -{{Math.round(Math.abs(parseFloat((item.abTrend.aaa* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:70px">
              <i v-if="Number(item.abTrend.qbr)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.abTrend.qbr)>=0">
                {{Math.round(parseFloat((item.abTrend.qbr* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.abTrend.qbr)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.abTrend.qbr)<0">
                -{{Math.round(Math.abs(parseFloat((item.abTrend.qbr* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:70px">
              <i v-if="Number(item.abTrend.msv)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.abTrend.msv)>=0">
                {{Math.round(parseFloat((item.abTrend.msv* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.abTrend.msv)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.abTrend.msv)<0">
                -{{Math.round(Math.abs(parseFloat((item.abTrend.msv* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:70px">
              <i v-if="Number(item.abTrend.swa)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.abTrend.swa)>=0">
                {{Math.round(parseFloat((item.abTrend.swa* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.abTrend.swa)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.abTrend.swa)<0">
                -{{Math.round(Math.abs(parseFloat((item.abTrend.swa* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:70px">
              <i v-if="Number(item.abTrend.sqms)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.abTrend.sqms)>=0">
                {{Math.round(parseFloat((item.abTrend.sqms* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.abTrend.sqms)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.abTrend.sqms)<0">
                -{{Math.round(Math.abs(parseFloat((item.abTrend.sqms* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:100px">
              <i v-if="Number(item.abTrend.govtCert)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.abTrend.govtCert)>=0">
                {{Math.round(parseFloat((item.abTrend.govtCert* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.abTrend.govtCert)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.abTrend.govtCert)<0">
                -{{Math.round(Math.abs(parseFloat((item.abTrend.govtCert* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:120px">
              <i v-if="Number(item.abTrend.specComp)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.abTrend.specComp)>=0">
                {{Math.round(parseFloat((item.abTrend.specComp* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.abTrend.specComp)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.abTrend.specComp)<0">
                -{{Math.round(Math.abs(parseFloat((item.abTrend.specComp* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:70px">
              <i v-if="Number(item.abTrend.coa)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.abTrend.coa)>=0">
                {{Math.round(parseFloat((item.abTrend.coa* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.abTrend.coa)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.abTrend.coa)<0">
                -{{Math.round(Math.abs(parseFloat((item.abTrend.coa* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:120px">
              <i v-if="Number(item.abTrend.regComp)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.abTrend.regComp)>=0">
                {{Math.round(parseFloat((item.abTrend.regComp* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.abTrend.regComp)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.abTrend.regComp)<0">
                -{{Math.round(Math.abs(parseFloat((item.abTrend.regComp* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:120px">
              <i v-if="Number(item.abTrend.govtPlant)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.abTrend.govtPlant)>=0">
                {{Math.round(parseFloat((item.abTrend.govtPlant* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.abTrend.govtPlant)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.abTrend.govtPlant)<0">
                -{{Math.round(Math.abs(parseFloat((item.abTrend.govtPlant* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:120px">
              <i v-if="Number(item.abTrend.stockRecovery)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.abTrend.stockRecovery)>=0">
                {{Math.round(parseFloat((item.abTrend.stockRecovery* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.abTrend.stockRecovery)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.abTrend.stockRecovery)<0">
                -{{Math.round(Math.abs(parseFloat((item.abTrend.stockRecovery* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:70px">
              <i v-if="Number(item.abTrend.qip)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.abTrend.qip)>=0">
                {{Math.round(parseFloat((item.abTrend.qip* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.abTrend.qip)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.abTrend.qip)<0">
                -{{Math.round(Math.abs(parseFloat((item.abTrend.qip* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:120px">
              <i v-if="Number(item.abTrend.feedback)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.abTrend.feedback)>=0">
                {{Math.round(parseFloat((item.abTrend.feedback* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.abTrend.feedback)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.abTrend.feedback)<0">
                -{{Math.round(Math.abs(parseFloat((item.abTrend.feedback* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:70px">
              <i v-if="Number(item.abTrend.sensory)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.abTrend.sensory)>=0">
                {{Math.round(parseFloat((item.abTrend.sensory* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.abTrend.sensory)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.abTrend.sensory)<0">
                -{{Math.round(Math.abs(parseFloat((item.abTrend.sensory* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:140px">
              <i v-if="Number(item.abTrend.consumerFeedback)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.abTrend.consumerFeedback)>=0">
                {{Math.round(parseFloat((item.abTrend.consumerFeedback* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.abTrend.consumerFeedback)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.abTrend.consumerFeedback)<0">
                -{{Math.round(Math.abs(parseFloat((item.abTrend.consumerFeedback* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:70px">
              <i v-if="Number(item.abTrend.dqmp)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.abTrend.dqmp)>=0">
                {{Math.round(parseFloat((item.abTrend.dqmp* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.abTrend.dqmp)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.abTrend.dqmp)<0">
                -{{Math.round(Math.abs(parseFloat((item.abTrend.dqmp* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:120px">
              <i v-if="Number(item.abTrend.rmcChick)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.abTrend.rmcChick)>=0">
                {{Math.round(parseFloat((item.abTrend.rmcChick* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.abTrend.rmcChick)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.abTrend.rmcChick)<0">
                -{{Math.round(Math.abs(parseFloat((item.abTrend.rmcChick* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:120px">
              <i v-if="Number(item.abTrend.rmcProduce)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.abTrend.rmcProduce)>=0">
                {{Math.round(parseFloat((item.abTrend.rmcProduce* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.abTrend.rmcProduce)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.abTrend.rmcProduce)<0">
                -{{Math.round(Math.abs(parseFloat((item.abTrend.rmcProduce* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:120px">
              <i v-if="Number(item.abTrend.antiChick)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.abTrend.antiChick)>=0">
                {{Math.round(parseFloat((item.abTrend.antiChick* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.abTrend.antiChick)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.abTrend.antiChick)<0">
                -{{Math.round(Math.abs(parseFloat((item.abTrend.antiChick* 100).toPrecision(12))))}}%
              </span>
            </td>
          </tr>
          <tr>
            <td style="width:80px">{{item.dPerformanceInfo.period}}</td>
            <td style="width:90px"></td>
            <td style="width:70px">D</td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.dPerformanceInfo.aaa* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.dPerformanceInfo.qbr* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.dPerformanceInfo.msv* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.dPerformanceInfo.swa* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.dPerformanceInfo.sqms* 100).toPrecision(12)))}}%
            </td>
            <td style="width:100px">
              {{Math.round(parseFloat((item.dPerformanceInfo.govtCert* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.dPerformanceInfo.specComp* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.dPerformanceInfo.coa* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.dPerformanceInfo.regComp* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.dPerformanceInfo.govtPlant* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.dPerformanceInfo.stockRecovery* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.dPerformanceInfo.qip* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.dPerformanceInfo.feedback* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.dPerformanceInfo.sensory* 100).toPrecision(12)))}}%
            </td>
            <td style="width:140px">
              {{Math.round(parseFloat((item.dPerformanceInfo.consumerFeedback* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.dPerformanceInfo.dqmp* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.dPerformanceInfo.rmcChick* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.dPerformanceInfo.rmcProduce* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.dPerformanceInfo.antiChick* 100).toPrecision(12)))}}%
            </td>
          </tr>
          <tr>
            <td style="width:80px"></td>
            <td style="width:90px">{{item.peerDPerformanceInfo.period}}</td>
            <td style="width:70px">D</td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.peerDPerformanceInfo.aaa* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.peerDPerformanceInfo.qbr* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.peerDPerformanceInfo.msv* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.peerDPerformanceInfo.swa* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.peerDPerformanceInfo.sqms* 100).toPrecision(12)))}}%
            </td>
            <td style="width:100px">
              {{Math.round(parseFloat((item.peerDPerformanceInfo.govtCert* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.peerDPerformanceInfo.specComp* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.peerDPerformanceInfo.coa* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.peerDPerformanceInfo.regComp* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.peerDPerformanceInfo.govtPlant* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.peerDPerformanceInfo.stockRecovery* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.peerDPerformanceInfo.qip* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.peerDPerformanceInfo.feedback* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.peerDPerformanceInfo.sensory* 100).toPrecision(12)))}}%
            </td>
            <td style="width:140px">
              {{Math.round(parseFloat((item.peerDPerformanceInfo.consumerFeedback* 100).toPrecision(12)))}}%
            </td>
            <td style="width:70px">
              {{Math.round(parseFloat((item.peerDPerformanceInfo.dqmp* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.peerDPerformanceInfo.rmcChick* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.peerDPerformanceInfo.rmcProduce* 100).toPrecision(12)))}}%
            </td>
            <td style="width:120px">
              {{Math.round(parseFloat((item.peerDPerformanceInfo.antiChick* 100).toPrecision(12)))}}%
            </td>
          </tr>
          <tr>
            <td style="width:170px" :colspan="2" class="table_td_grade" @click="dClick(item)">Grade D 趋势</td>
            <td style="width:70px">D</td>
            <td style="width:70px">
              <i v-if="Number(item.dTrend.aaa)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.dTrend.aaa)>=0">
                {{Math.round(parseFloat((item.dTrend.aaa* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.dTrend.aaa)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.dTrend.aaa)<0">
                -{{Math.round(Math.abs(parseFloat((item.dTrend.aaa* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:70px">
              <i v-if="Number(item.dTrend.qbr)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.dTrend.qbr)>=0">
                {{Math.round(parseFloat((item.dTrend.qbr* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.dTrend.qbr)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.dTrend.qbr)<0">
                -{{Math.round(Math.abs(parseFloat((item.dTrend.qbr* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:70px">
              <i v-if="Number(item.dTrend.msv)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.dTrend.msv)>=0">
                {{Math.round(parseFloat((item.dTrend.msv* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.dTrend.msv)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.dTrend.msv)<0">
                -{{Math.round(Math.abs(parseFloat((item.dTrend.msv* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:70px">
              <i v-if="Number(item.dTrend.swa)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.dTrend.swa)>=0">
                {{Math.round(parseFloat((item.dTrend.swa* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.dTrend.swa)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.dTrend.swa)<0">
                -{{Math.round(Math.abs(parseFloat((item.dTrend.swa* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:70px">
              <i v-if="Number(item.dTrend.sqms)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.dTrend.sqms)>=0">
                {{Math.round(parseFloat((item.dTrend.sqms* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.dTrend.sqms)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.dTrend.sqms)<0">
                -{{Math.round(Math.abs(parseFloat((item.dTrend.sqms* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:100px">
              <i v-if="Number(item.dTrend.govtCert)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.dTrend.govtCert)>=0">
                {{Math.round(parseFloat((item.dTrend.govtCert* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.dTrend.govtCert)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.dTrend.govtCert)<0">
                -{{Math.round(Math.abs(parseFloat((item.dTrend.govtCert* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:120px">
              <i v-if="Number(item.dTrend.specComp)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.dTrend.specComp)>=0">
                {{Math.round(parseFloat((item.dTrend.specComp* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.dTrend.specComp)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.dTrend.specComp)<0">
                -{{Math.round(Math.abs(parseFloat((item.dTrend.specComp* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:70px">
              <i v-if="Number(item.dTrend.coa)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.dTrend.coa)>=0">
                {{Math.round(parseFloat((item.dTrend.coa* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.dTrend.coa)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.dTrend.coa)<0">
                -{{Math.round(Math.abs(parseFloat((item.dTrend.coa* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:120px">
              <i v-if="Number(item.dTrend.regComp)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.dTrend.regComp)>=0">
                {{Math.round(parseFloat((item.dTrend.regComp* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.dTrend.regComp)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.dTrend.regComp)<0">
                -{{Math.round(Math.abs(parseFloat((item.dTrend.regComp* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:120px">
              <i v-if="Number(item.dTrend.govtPlant)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.dTrend.govtPlant)>=0">
                {{Math.round(parseFloat((item.dTrend.govtPlant* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.dTrend.govtPlant)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.dTrend.govtPlant)<0">
                -{{Math.round(Math.abs(parseFloat((item.dTrend.govtPlant* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:120px">
              <i v-if="Number(item.dTrend.stockRecovery)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.dTrend.stockRecovery)>=0">
                {{Math.round(parseFloat((item.dTrend.stockRecovery* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.dTrend.stockRecovery)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.dTrend.stockRecovery)<0">
                -{{Math.round(Math.abs(parseFloat((item.dTrend.stockRecovery* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:70px">
              <i v-if="Number(item.dTrend.qip)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.dTrend.qip)>=0">
                {{Math.round(parseFloat((item.dTrend.qip* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.dTrend.qip)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.dTrend.qip)<0">
                -{{Math.round(Math.abs(parseFloat((item.dTrend.qip* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:120px">
              <i v-if="Number(item.dTrend.feedback)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.dTrend.feedback)>=0">
                {{Math.round(parseFloat((item.dTrend.feedback* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.dTrend.feedback)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.dTrend.feedback)<0">
                -{{Math.round(Math.abs(parseFloat((item.dTrend.feedback* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:70px">
              <i v-if="Number(item.dTrend.sensory)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.dTrend.sensory)>=0">
                {{Math.round(parseFloat((item.dTrend.sensory* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.dTrend.sensory)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.dTrend.sensory)<0">
                -{{Math.round(Math.abs(parseFloat((item.dTrend.sensory* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:140px">
              <i v-if="Number(item.dTrend.consumerFeedback)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.dTrend.consumerFeedback)>=0">
                {{Math.round(parseFloat((item.dTrend.consumerFeedback* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.dTrend.consumerFeedback)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.dTrend.consumerFeedback)<0">
                -{{Math.round(Math.abs(parseFloat((item.dTrend.consumerFeedback* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:70px">
              <i v-if="Number(item.dTrend.dqmp)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.dTrend.dqmp)>=0">
                {{Math.round(parseFloat((item.dTrend.dqmp* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.dTrend.dqmp)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.dTrend.dqmp)<0">
                -{{Math.round(Math.abs(parseFloat((item.dTrend.dqmp* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:120px">
              <i v-if="Number(item.dTrend.rmcChick)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.dTrend.rmcChick)>=0">
                {{Math.round(parseFloat((item.dTrend.rmcChick* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.dTrend.rmcChick)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.dTrend.rmcChick)<0">
                -{{Math.round(Math.abs(parseFloat((item.dTrend.rmcChick* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:120px">
              <i v-if="Number(item.dTrend.rmcProduce)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.dTrend.rmcProduce)>=0">
                {{Math.round(parseFloat((item.dTrend.rmcProduce* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.dTrend.rmcProduce)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.dTrend.rmcProduce)<0">
                -{{Math.round(Math.abs(parseFloat((item.dTrend.rmcProduce* 100).toPrecision(12))))}}%
              </span>
            </td>
            <td style="width:120px">
              <i v-if="Number(item.dTrend.antiChick)>0" class="el-icon-top redClass"></i>
              <span v-if="Number(item.dTrend.antiChick)>=0">
                {{Math.round(parseFloat((item.dTrend.antiChick* 100).toPrecision(12)))}}%
              </span>
              <i v-if="Number(item.dTrend.antiChick)<0" class="el-icon-bottom greenClass"></i>
              <span v-if="Number(item.dTrend.antiChick)<0">
                -{{Math.round(Math.abs(parseFloat((item.dTrend.antiChick* 100).toPrecision(12))))}}%
              </span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <el-dialog title="对比情况" :visible.sync="dialogVisible" width="70%" :before-close="handleClose">
      <div v-if="dialogVisible" id="barChart" ref="Echart" style="width:100%;height:500px"></div>
    </el-dialog>
  </div>
</template>
<script>
import store from '@/store/index'
import IcSelect from "@/components/common/icSelect";
import qspiReport from "@/api/qspiReport/index";
import paginationMixin from '@/mixins/pagitionMixin';
import commonFunction from "@/utils/dataTableUtils";
import { fileService } from "@/api/common/file-utils";
export default {
  name: 'fspi',
  mixins: [paginationMixin],
  components: {
    IcSelect,
  },
  data() {
    return {
      dialogVisible: false,
      year: "",
      quarter: "",
      month: "",
      queryCondition: {
        peerRatingPeriod: "",
        ratingPeriod: "",
        pageSize: 15,
        pageNum: 1,
      },
      quarterOptions: [
        {
          label: "All",
          key: ''
        },
        {
          label: "Q1",
          key: "Q1",
        },
        {
          label: "Q2",
          key: "Q2",
        },
        {
          label: "Q3",
          key: "Q3",
        },
        {
          label: "Q4",
          key: "Q4",
        }
      ],
      monthOptions: [
        {
          label: "All",
          key: '',
          quarter: ''
        },
        {
          label: "一月",
          key: "01",
          quarter: "Q1",
        },
        {
          label: "二月",
          key: "02",
          quarter: "Q1",
        },
        {
          label: "三月",
          key: "03",
          quarter: "Q1",
        },
        {
          label: "四月",
          key: "04",
          quarter: "Q2",
        },
        {
          label: "五月",
          key: "05",
          quarter: "Q2",
        },
        {
          label: "六月",
          key: "06",
          quarter: "Q2",
        },
        {
          label: "七月",
          key: "07",
          quarter: "Q3",
        },
        {
          label: "八月",
          key: "08",
          quarter: "Q3",
        },
        {
          label: "九月",
          key: "09",
          quarter: "Q3",
        },
        {
          label: "十月",
          key: "10",
          quarter: "Q4",
        },
        {
          label: "十一月",
          key: "11",
          quarter: "Q4",
        },
        {
          label: "十二月",
          key: "12",
          quarter: "Q4",
        }
      ],
      supplierData1: [],
      actualVolumeData1: [],
      percentageData1: [],
      supplierData2: [],
      actualVolumeData2: [],
      percentageData2: [],
      tableLists: [],
      labelData: [],
      valueData: [],
      labelName: ""
    }
  },
  created() {
    // toPrecision 是处理精度，精度是从左至右第一个不为0的数开始数起。
    // 为什么选择 12 做为默认精度？这是一个经验的选择，一般选12就能解决掉大部分0001和0009问题，而且大部分情况下也够用了，如果你需要更精确可以调高。
  },
  methods: {
    queryData() {
      if (!this.queryCondition.ratingPeriod) {
        this.$message.error('请输入评价时间')
        return false
      }
      if (!this.queryCondition.peerRatingPeriod) {
        this.$message.error('请输入对比评价时间')
        return false
      }
      qspiReport.queryQspiMonthlyAnalysis(this.queryCondition.ratingPeriod, this.queryCondition.peerRatingPeriod).then(res => {
        this.tableLists = res
        console.log('res', res);
      });
    },
    getTableLable() {
      qspiReport.getQspiMonthlyTbleLabel('SWA', this.queryCondition.ratingPeriod).then(res => {
        console.log("GY🚀 ~ qspiReport.getQspiMonthlyTbleLabel ~ res:", res);
        this.labelName = res
      });
    },
    onAdd() {
      if (!this.year) {
        this.$message.error('请选择年份')
        return false
      }
      this.queryCondition.ratingPeriod = ''
      if (!this.quarter && !this.month) {
        this.queryCondition.ratingPeriod = this.year
      } else if (this.quarter && !this.month) {
        this.queryCondition.ratingPeriod = this.year + '-' + this.quarter
      } else if (!this.quarter && this.month) {
        this.queryCondition.ratingPeriod = this.year + '-' + this.month
      } else if (this.quarter && this.month) {
        this.queryCondition.ratingPeriod = this.year + '-' + this.month
      } else {
        this.queryCondition.ratingPeriod = ''
      }
    },
    onContrast() {
      if (!this.year) {
        this.$message.error('请选择年份')
        return false
      }
      var temp = this.queryCondition.peerRatingPeriod ? (this.queryCondition.peerRatingPeriod + ',') : this.queryCondition.peerRatingPeriod
      var str = temp
      if (!this.quarter && !this.month) {
        str = str + this.year
      } else if (this.quarter && !this.month) {
        str = str + (this.year + '-' + this.quarter)
      } else if (!this.quarter && this.month) {
        str = str + (this.year + '-' + this.month)
      } else if (this.quarter && this.month) {
        str = str + (this.year + '-' + this.month)
      } else {
        str = ''
      }
      console.log('str', str);
      temp = str
      var arr = [...new Set(temp.split(','))]
      console.log('arr', arr);
      this.queryCondition.peerRatingPeriod = arr.join(',')
    },
    quarterChange(val) {
      console.log('val', val);
      this.monthOptions = [
        {
          label: "All",
          key: '',
          quarter: ''
        },
        {
          label: "一月",
          key: "01",
          quarter: "Q1",
        },
        {
          label: "二月",
          key: "02",
          quarter: "Q1",
        },
        {
          label: "三月",
          key: "03",
          quarter: "Q1",
        },
        {
          label: "四月",
          key: "04",
          quarter: "Q2",
        },
        {
          label: "五月",
          key: "05",
          quarter: "Q2",
        },
        {
          label: "六月",
          key: "06",
          quarter: "Q2",
        },
        {
          label: "七月",
          key: "07",
          quarter: "Q3",
        },
        {
          label: "八月",
          key: "08",
          quarter: "Q3",
        },
        {
          label: "九月",
          key: "09",
          quarter: "Q3",
        },
        {
          label: "十月",
          key: "10",
          quarter: "Q4",
        },
        {
          label: "十一月",
          key: "11",
          quarter: "Q4",
        },
        {
          label: "十二月",
          key: "12",
          quarter: "Q4",
        }
      ]
      if (val === 'Q1') {
        this.monthOptions = this.monthOptions.filter(ele => {
          return ele.quarter === 'Q1' || !ele.quarter
        })
      } else if (val === 'Q2') {
        this.monthOptions = this.monthOptions.filter(ele => {
          return ele.quarter === 'Q2' || !ele.quarter
        })
      } else if (val === 'Q3') {
        this.monthOptions = this.monthOptions.filter(ele => {
          return ele.quarter === 'Q3' || !ele.quarter
        })
      } else if (val === 'Q4') {
        this.monthOptions = this.monthOptions.filter(ele => {
          return ele.quarter === 'Q4' || !ele.quarter
        })
      } else {
        this.monthOptions = this.monthOptions
      }
    },
    abClick(item) {
      console.log("item", item);
      this.labelData = []
      this.valueData = []
      item.abTrendForChart.forEach(ele => {
        this.labelData.push(ele.name)
        // this.valueData.push(parseFloat((ele.value * 100).toPrecision(12)))
        if (Number(ele.value) < 0) {
          this.valueData.push('-' + Math.round(Math.abs(parseFloat((ele.value * 100).toPrecision(12)))))
        } else {
          this.valueData.push(Math.round(parseFloat((ele.value * 100).toPrecision(12))))
        }
      })
      console.log("🚀 ~ file: qspiMonthlyAnalysis.vue ~ line 830 ~ abClick ~ this.valueData", this.valueData)
      console.log("🚀 ~ file: qspiMonthlyAnalysis.vue ~ line 829 ~ abClick ~ this.labelData", this.labelData)
      this.dialogVisible = true
      setTimeout(() => {
        this.drawCharts(this.labelData, this.valueData, item.abTrendForChart)
      }, 1000)
    },
    dClick(item) {
      console.log("item", item);
      this.labelData = []
      this.valueData = []
      item.dTrendForChart.forEach(ele => {
        this.labelData.push(ele.name)
        if (Number(ele.value) < 0) {
          this.valueData.push('-' + Math.round(Math.abs(parseFloat((ele.value * 100).toPrecision(12)))))
        } else {
          this.valueData.push(Math.round(parseFloat((ele.value * 100).toPrecision(12))))
        }
      })
      console.log("🚀 ~ file: qspiMonthlyAnalysis.vue ~ line 849 ~ dClick ~ this.labelData", this.labelData)
      console.log("🚀 ~ file: qspiMonthlyAnalysis.vue ~ line 851 ~ dClick ~ this.valueData", this.valueData)
      this.dialogVisible = true
      setTimeout(() => {
        this.drawCharts(this.labelData, this.valueData, item.dTrendForChart)
      }, 1000)
    },
    drawCharts(labelData, valueData, barList) {
      console.log('barList', barList);
      console.log('labelData', labelData);
      console.log('barChart', document.getElementById('barChart'));
      var chartDom = document.getElementById('barChart');
      var myChart = this.$echarts.init(chartDom);
      var option;
      option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
        },
        legend: {
          itemHeight: 14,
          itemWidth: 14,
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          splitLine: { show: false },
          axisLabel: {
            interval: 0, //全部显示x轴
            rotate: 40//label文字倾斜
          },
          data: labelData,
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}%'
          }
        },
        series: [
          {
            data: valueData,
            type: 'bar',
            label: {
              show: true,
              position: 'inside',
              formatter: "{c}%"
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  console.log('params', params);
                  if (params.data > 0) {
                    return 'red'
                  } else {
                    return 'green'
                  }
                }
              }
            },
          }
        ]
      };

      option && myChart.setOption(option);
    },
    handleClose() {
      this.dialogVisible = false
    },
    onSearch() {
      this.queryData()
      this.getTableLable()
    },
    onReset() {
      this.year = ""
      this.quarter = ""
      this.month = ""
      this.queryCondition = {
        peerRatingPeriod: "",
        ratingPeriod: "",
        pageSize: 15,
        pageNum: 1,
      }
      this.tableLists = []
    },
    onExport() {
      if (!this.queryCondition.ratingPeriod) {
        this.$message.error('请输入评价时间')
        return false
      }
      if (!this.queryCondition.peerRatingPeriod) {
        this.$message.error('请输入对比评价时间')
        return false
      }
      qspiReport.exportQspiMonthlyAnalysis(this.queryCondition.ratingPeriod, this.queryCondition.peerRatingPeriod).then(res => {
        fileService.respToFile(res, 'QSPI_Monthly Analysis报表.xlsx');
      });
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
.table {
  border-collapse: collapse;
  margin-bottom: 12px;
  font-size: 14px;
  width: 100%;
  table-layout: fixed;
}
.table td {
  border: 1px solid #d7dbe4;
  color: rgba(59, 67, 77, 1);
  padding: 9px 10px 10px;
  font-size: 14px;
  font-weight: 400;
  background: #fff;
  text-align: center;
  /* width: 20%; */
}
.table .table_td {
  background: #eee;
}
.table .table_td_grade {
  color: #f59a23;
}
</style>
